const items = [
    { icon: "fa-shield-halved", label: "No lock-in contracts" },
    { icon: "fa-calendar-check", label: "Cancel with 30 days' notice" },
    { icon: "fa-gauge-high", label: "Results in 2–4 weeks" },
    { icon: "fa-comments", label: "Reply within 24 hours" },
    { icon: "fa-lock", label: "You own everything we ship" },
];
export default function TrustStrip() {
    return (
        <section data-testid="trust-strip" className="relative py-8 border-y border-[#1F3A2B] bg-[#152A20]">
            <div className="max-w-[1240px] mx-auto px-8 flex flex-wrap items-center justify-center gap-x-10 gap-y-4">
                {items.map((it) => (
                    <div key={it.label} className="flex items-center gap-2.5 text-[13px] text-[#B8CFC0]">
                        <i className={`fa-solid ${it.icon} text-[#DFFF3D] text-[13px]`} />
                        <span>{it.label}</span>
                    </div>
                ))}
            </div>
        </section>
    );
}
